export default __webpack_public_path__ + "static/media/inspire2.54513f48.svg";